import axios from "../../axios-api";

export const getGenericEmailTypes = (token, targetApp) => {
  const requestUrl = `/mailing/generic-email-type`;

  const filter = [];

  if (targetApp) {
    filter.push({
      property: "targetApp",
      value: targetApp,
      operator: "eq",
    });
  }

  const sort = [
    {
      property: "id",
      dir: "asc",
    },
  ];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      nolimit: 1,
      sort: JSON.stringify(sort),
    },
  });
};

export const createGenericEmailType = (token, data) => {
  const requestUrl = `/mailing/generic-email-type`;

  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("id", data.code);
  formData.append("targetApp", data.targetApp);
  ["Fr", "Nl", "En"].forEach((lng) => {
    formData.append(`label${lng}`, data[`label${lng}`] || "");
  });
  formData.append("rank", data.rank);
  if (data.updatedBy) {
    formData.append("updatedBy", data.updatedBy);
  }

  return axios.post(requestUrl, formData);
};

export const deleteGenericEmailType = (token, code, targetApp, configId, scope) => {
  const requestUrl = `/mailing/generic-email-type/${encodeURIComponent(
    code,
  )}/${encodeURIComponent(targetApp)}`;

  const formData = new FormData();
  formData.append("access_token", token);
  // formData.append("_method", "delete");
  if (configId != null) {
    formData.append("configId", configId);
  }
  // "global" = delete the catalog type definitely; "config" = remove it from
  // the current config only.
  formData.append("scope", scope || "global");

  return axios.post(requestUrl, formData);
};
